import { render, staticRenderFns } from "./ImoFalFormsGeneralModals.vue?vue&type=template&id=9762fcfa"
import script from "./ImoFalFormsGeneralModals.vue?vue&type=script&lang=js"
export * from "./ImoFalFormsGeneralModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports